import { ApplicationConfig, importProvidersFrom, provideNgReflectAttributes, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from '@app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RsCustomMatIconsModule } from '@rs-shared-lib/modules/rs-core/modules/rs-custom-mat-icons.module';
import { RsCoreModule } from '@rs-shared-lib/modules/rs-core/rs-core.module';
import { UserInfoCookieAppName } from '@rs-shared-lib/modules/rs-core/modules/rs-authentication/enums/UserInfoCookieAppName.enum';
import { environment } from '@environments/environment';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { DateAdapter } from '@angular/material/core';
import { RsNativeDateAdapter } from '@rs-shared-lib/shared/adapters/rs-native-date-adapter';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

// Material configurations
const globalDialogDefaultsOptions: MatDialogConfig = {
  width: '800px',
};

const globalMatFormFieldDefaultOptions: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  subscriptSizing: 'dynamic',
};

const materialProviders = [
  { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: globalDialogDefaultsOptions },
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: globalMatFormFieldDefaultOptions },
  { provide: DateAdapter, useClass: RsNativeDateAdapter },
  // Since CDK v21, overlays (dialogs, selects, ...) render as native popovers in the browser's
  // top layer, which paints above everything regardless of z-index. This hid ngx-toastr toasts
  // (RsMessagesHandlerService) behind open dialog backdrops, so keep overlays on z-index stacking.
  // https://github.com/scttcper/ngx-toastr/issues/1053
  // Also ngx-toastr is no longer maintained, we need to look for an alternative
  { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }
];


export const appConfig: ApplicationConfig = {
  providers: [
    // Do not rely on ng-reflect attributes; they are planned for deprecation in the future.
    provideNgReflectAttributes(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideAnimations(),
    importProvidersFrom(
      RsCustomMatIconsModule,
      RsCoreModule.forRoot({
        appName: UserInfoCookieAppName.MOBICLEAR,
        environment,
      }),
    ),
    ...materialProviders
  ],
}
